import SubHeader from "./fragments/SubHeader";
import 'bootstrap/dist/css/bootstrap.min.css';
import POList from "./fragments/POList";
import {useDispatch, useSelector} from "react-redux";
import {searchPo, selectPo} from "../../redux/slices/purchassingOrder";
import {useMemo, useState} from "react";
import {FILTER_INITIAL_STATE} from "./constants";
import InfinityScroll from "../../shared/components/InfinityScroll";
import LoadMoreSpinner from './../../shared/components/LoadMoreSpinner';
import { STATUS_PENDING } from './../../constants';

let isInitialized = false;

export default function PurchaseOrderTogo() {
    const [filter, setFilter] = useState(FILTER_INITIAL_STATE)

    const {noResult, status, togoList } = useSelector(selectPo);

    const dispatch = useDispatch();

    const totalCost = useMemo(() => {
        let total = 0; 

        togoList?.forEach( PO =>{
            if(PO?.Currency !== "FCFA" || PO?.Currency === null){
                PO.Purchases.forEach(e =>
                    {
                        total += e.Amount
                    })
            }
        })
        return total;

    }, [togoList])
   
    const totalCostFCFA = useMemo(() => {

        let total = 0;
        togoList?.forEach( PO =>{
            if(PO?.Currency === "FCFA"){
                PO.Purchases.forEach(e =>
                    {
                        total += e.Amount
                    })
            }
        })
        return total;

    }, [togoList])
   

    const nbPos = useMemo(() => {
        return !togoList ? 0 : togoList.length;
    }, [togoList])

    if (!isInitialized) {
        isInitialized = true;
        dispatch(searchPo({}));
    }

    const handleFilterChange = (filter) => {
        dispatch(searchPo({filter: filter}))
        setFilter(filter)
    }

    const handleLoadMore = () => dispatch(searchPo({filter: filter}))
    // console.log( "hjhjh" , list)
    // console.log( "ooooo" , list[0])
    // console.log( "iiii" , list[0].id)
    // console.log( "ffff" , list[0].Purchases)
    // console.log("LIst"+JSON.stringify(list[0]))
    // console.log("LIst ze "+JSON.stringify(list[0].Purchases))
    // console.log(nbPos)
    // console.log(totalCost)

    return (
        <main>
            <SubHeader totalCost={totalCost} totalCostFCFA={totalCostFCFA} numberPOs={nbPos} onFilterChange={handleFilterChange}/>

            <div style={{height: 20}}/>
           {togoList && 
           <InfinityScroll data={togoList} hasMore={!noResult} loadMoreAction={handleLoadMore}>
                <POList items={togoList}/>
            </InfinityScroll>}

            {
                status === STATUS_PENDING &&
                <LoadMoreSpinner number={12} />
            }

        </main>
    )
}
